import { AutomationActions, AutomationEvents } from "../../../../core/Enums"
import { FontAwesomeIcons } from "../../../../core/Types"


export interface AutomationLabel<T> {
    id: T
    name: string
    icon: FontAwesomeIcons
}

// Some events need a parameter of their own before they mean anything: which statuses
// count as a match, or how long to wait. `param` is what the form renders for them.
export type AutomationEventParam = "statuses" | "minutesAfterAccept" | "minutesBeforeAppt"

export interface AutomationEventLabel extends AutomationLabel<AutomationEvents> {
    param?: AutomationEventParam
}

// The wording the rule form, the list and the filters all read from. Mirrors
// AutomationRulesMapper.ToLabel() on the server. The order here is the order the
// form's dropdown shows them in.
export const AUTOMATION_EVENTS: AutomationEventLabel[] = [
    { id: AutomationEvents.JobCreated, name: "When a job is created", icon: "circle-plus" },
    { id: AutomationEvents.JobStatusChanged, name: "When a job's status changes", icon: "arrow-right-arrow-left", param: "statuses" },
    { id: AutomationEvents.TechAcceptedJob, name: "When the technician accepts the job", icon: "circle-check" },
    { id: AutomationEvents.TechRejectedJob, name: "When the technician rejects the job", icon: "circle-xmark" },
    { id: AutomationEvents.TechDidNotCallCustomer, name: "When the technician hasn't called the customer", icon: "phone-slash", param: "minutesAfterAccept" },
    { id: AutomationEvents.TechFirstCallToCustomer, name: "When the technician calls the customer for the first time", icon: "phone-arrow-up-right" },
    { id: AutomationEvents.TechCallToCustomer, name: "Every time the technician calls the customer", icon: "phone" },
    { id: AutomationEvents.BeforeAppointment, name: "Before the appointment time", icon: "clock", param: "minutesBeforeAppt" },
]

export const AUTOMATION_ACTIONS: AutomationLabel<AutomationActions>[] = [
    { id: AutomationActions.ChangeJobStatus, name: "Change the job status", icon: "arrow-right-arrow-left" },
    { id: AutomationActions.SendJobToTechnician, name: "Send the job to the technician", icon: "paper-plane" },
    { id: AutomationActions.SendMessageToTechnician, name: "Send a message to the technician", icon: "comment" },
    { id: AutomationActions.SendMessageToCustomer, name: "Send a message to the customer", icon: "comments" },
    { id: AutomationActions.SendNotification, name: "Send a notification", icon: "bell" },
]

export const automationEventLabel = (value?: AutomationEvents) =>
    AUTOMATION_EVENTS.find(e => e.id === value)

export const automationActionLabel = (value?: AutomationActions) =>
    AUTOMATION_ACTIONS.find(a => a.id === value)
